import { Component, OnInit } from '@angular/core';
import { GlobalService } from '../../services/global.service';

@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.less']
})
export class LayoutComponent implements OnInit {

  nowYear:any = new Date().getFullYear();
  constructor(public global:GlobalService) { }

  ngOnInit(): void {
  }

}
